var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"controls"},[(_vm.name != null)?_c('div',{staticClass:"name censor"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('div',{staticClass:"buttons"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }